import PropTypes from 'prop-types';
import React from 'react';

import {
  Message,
} from 'rebass';

import { inputInfoShape } from 'shared/addonInput';

import {
  Icon,
} from 'frontend/components';

const SimcInputError = ({ inputInfo }) => {
  let inputError;
  let inputErrorLevel = 'warning';

  if (inputInfo) {
    // can generally be trusted, does not need a warning/error
    if (inputInfo.source === 'raidbots') {
      return null;
    }

    if (inputInfo.source === 'raidbots') {
      inputError = 'raidbotsGenerated';
    } else if (!inputInfo.validSource) {
      inputError = 'invalidSource';
      inputErrorLevel = 'error';
    } else if (inputInfo.invalidChecksum) {
      if (inputInfo.invalidMainBodyChecksum) {
        inputError = 'mainBodyEdited';
        inputErrorLevel = 'error';
      } else {
        inputError = 'textAdded';
      }
    } else if (!inputInfo.wowVersionValid) {
      inputErrorLevel = 'error';
      inputError = 'invalidWowVersion';
    }
  }

  const inputErrorMessages = {
    invalidSource: (
      `Input was not copied directly from the SimC addon. ` +
      `Raidbots tools are not guaranteed to work as expected.`
    ),
    mainBodyEdited: (
      `Addon input has been edited. ` +
      `Raidbots tools are not guaranteed to work as expected.`
    ),
    textAdded: (
      `Additions have been made to the addon input. ` +
      `Raidbots tools are not guaranteed to work as expected.`
    ),
    invalidWowVersion: (
      `Raidbots does not support characters from this version of WoW. ` +
      `Only the current version is supported.`
    ),
  };


  if (inputError) {
    return (
      <Message theme={inputErrorLevel} p={1} mt={0}>
        <Icon name="warning" size={20} style={{ marginRight: 10 }} />
        {inputErrorMessages[inputError]}
      </Message>
    );
  }

  return null;
};

SimcInputError.propTypes = {
  inputInfo: PropTypes.shape(inputInfoShape),
};

SimcInputError.defaultProps = {
  inputInfo: false,
};

export default SimcInputError;
